<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div v-if="!isOffline" class="box-header text-center hidden-xs">
            <div id="process-1" class="process-elem">
              建立 <div class="p-t-50">{{orderList.create_time}}</div>
            </div>
            <div id="process-2" class="process-elem">
              下訂 <div class="p-t-50">{{orderList.order_time}}</div>
            </div>
            <div id="process-3" class="process-elem">
              <span :class="{'text-worning': !orderList.settle_time && orderList.invoice_issue_time}">結帳</span>
              <div class="p-t-50">{{orderList.settle_time}}</div>
            </div>
            <div id="process-4" class="process-elem">
              <span :class="{'text-worning': orderList.settle_time && !orderList.invoice_issue_time}">開立發票</span>
              <div class="p-t-50">{{orderList.invoice_issue_time}}</div>
            </div>
            <div class="progress-block">
              <div class="progress">
                <div v-if="orderList.invoice_issue_time" class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                <div v-else-if="orderList.settle_time" class="progress-bar" role="progressbar" style="width: calc(100% / 3 * 2)" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                <div v-else class="progress-bar" role="progressbar" style="width: calc(100% / 3)" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>
          <div class="box-body form-left p-l-10 p-r-10-p">
            <br />
            <div v-if="!isOffline">
              <div class="input-group">
                <span class="input-group-addon bg-blue" style="border: 1px solid #0073b7">
                  產品明細
                </span>
                <button class="btn btn-default" data-target="#orderDetailModal" data-toggle="modal">
                  <i class="fa fa-list" aria-hidden="true"></i> 產品內容
                </button>
              </div>
              <br />
            </div>
            <div v-if="orderList.allowance && orderList.allowance.length">
              <div class="input-group">
                <span class="input-group-addon bg-blue" style="border: 1px solid #0073b7">
                  折讓金額
                </span>
                <button class="btn btn-default" data-target="#allowanceModal" data-toggle="modal">
                  <i class="fa fa-list" aria-hidden="true"></i> 折讓內容
                </button>
              </div>
              <br />
            </div>
            <div v-if="getCouponList.length">
              <div class="input-group">
                <span class="input-group-addon bg-blue" style="border: 1px solid #0073b7">
                  獲得優惠券明細
                </span>
                <button class="btn btn-default" data-target="#getCouponDetailModal" data-toggle="modal">
                  <i class="fa fa-list" aria-hidden="true"></i> 獲得優惠券內容
                </button>
              </div>
              <br />
            </div>
            <div v-if="getPointList.length || getMembershipScore.length">
              <div class="input-group">
                <span class="input-group-addon bg-blue" style="border: 1px solid #0073b7">
                  獲得點數/積分明細
                </span>
                <button class="btn btn-default" data-target="#getPointDetailModal" data-toggle="modal">
                  <i class="fa fa-list" aria-hidden="true"></i> 獲得內容
                </button>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  {{isGuest?'POS機':''}}訂單編號
                </span>
                <div class="form-control form-info">
                  {{ isGuest ? orderList.pos_order_sn : orderList.order_sn || '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isGuest">
              <div class="input-group">
                <span class="input-group-addon">
                  訂單ID
                </span>
                <div class="form-control form-info">
                  {{orderList.order_id?orderList.order_id:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  訂單狀態
                </span>
                <div class="form-control form-info">
                  <div class="status-light inline-block" :class="orderStateColor(orderList.status)"></div>
                  <div class="inline-block" style="line-height: 23px">&nbsp;{{orderState(orderList.status)}}({{orderList.status}})&nbsp;</div>

                  <!-- 修改訂單狀態 -->
                  <!-- 顯示按鈕「管理者 & 線上訂單」 -->
                  <button v-if="roleType === 99 && !isOffline" class="btn btn-danger m-r-5 m-y-5" data-toggle="modal" data-target="#editOrderStateModal">
                    修改訂單狀態
                  </button>
                  <!-- End 修改訂單狀態 -->
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  訂購者<span v-if="isGuest">姓名</span><span v-else-if="roleType === 99">(ID)</span>
                </span>
                <div class="form-control form-info" :class="{'text-red': orderList.shopper_black_info}">
                  {{orderList.name?orderList.name:'無資料'}}<span v-if="roleType === 99 && !isGuest">({{orderList.shopper_id}})</span>&nbsp;&nbsp;
                  <template v-if="!isGuest">
                    <!-- 如果是黑名單用戶shopper_black_info，顯示哭臉，不是黑名單用戶，顯示笑臉 -->
                    <i
                      class="fa c-pointer text-25"
                      :class="[orderList.shopper_black_info ? 'fa-frown-o' : 'fa-smile-o text-yellow']"
                      aria-hidden="true"
                      style="top: 2.5px"
                      data-toggle="modal"
                      data-target="#openModal">
                    </i>
                  </template>
                  &nbsp;&nbsp;
                  <router-link :to="{path: '/memberOrderTable/' + orderList.shopper_id}" target="_blank">
                    <i v-if="(roleType === 99 || roleType === 30) && checkMemberShow(orderList.status)" class="fa fa-list-alt c-pointer text-primary text-25" aria-hidden="true" style="top: 3.5px"></i>
                  </router-link>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  訂購者電話
                </span>
                <div class="form-control form-info">
                  {{orderList.phone?orderList.phone:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  預定取餐時間
                </span>
                <div class="form-control form-info">
                  <span v-if="orderList.order_method === 2" class="label label-success" style="line-height: 25px">預</span>
                  {{orderList.delivery_reserv_time?orderList.delivery_reserv_time:'無資料'}}<span v-if="orderList.delivery_reserv_tolerance"> ~ {{reservEndTime?reservEndTime:'無資料'}}</span>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  取餐類型
                </span>
                <div class="form-control form-info">
                  {{orderList.delivery_type | deliveryName}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.delivery_type === 21">
              <div class="input-group">
                <span class="input-group-addon">
                  桌號
                </span>
                <div class="form-control form-info">
                  {{orderList.table_no || '無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.order_special_item_setting && Array.isArray(orderList.order_special_item_setting) && orderList.order_special_item_setting[0]">
              <div class="input-group">
                <span class="input-group-addon">
                  特殊需求
                </span>
                <div class="form-control form-info" v-if="orderList.order_special_item_setting[0].value">
                  {{orderList.order_special_item_setting[0].turn_on_text}}
                </div>
                <div class="form-control form-info" v-else-if="!orderList.order_special_item_setting[0].value">
                  {{orderList.order_special_item_setting[0].turn_off_text}}
                </div>
              </div>
              <br />
            </div>

            <div v-if="orderList.src_type && !isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  訂單來源
                </span>
                <div class="form-control form-info">
                  {{ orderSource(orderList.src_type) ? orderSource(orderList.src_type) : '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.sub_src_type && !isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  訂單瀏覽器來源
                </span>
                <div class="form-control form-info">
                  {{ subSrcType ? subSrcType : '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.delivery_type == 3 && !isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  外送地址
                </span>
                <div class="form-control form-info">
                  <a target="_blank" :href="getShortAddress(orderList.address)">{{orderList.address}}</a>
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.delivery_type == 3 && !isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  預估與店家距離
                </span>
                <div class="form-control form-info">
                  {{orderList.distance / 1000}} 公里
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  訂單狀態紀錄
                </span>
                <button class="btn btn-default" data-target="#statusTrackingModal" data-toggle="modal">
                  <i class="fa fa-info-circle" aria-hidden="true"></i> 詳細內容
                </button>
              </div>
              <br />
            </div>
            <div v-if="orderList.notify_history && orderList.notify_history.length">
              <div class="input-group">
                <span class="input-group-addon">
                  門市通知紀錄
                </span>
                <button class="btn btn-default" data-target="#notifyHistoryModal" data-toggle="modal">
                  <i class="fa fa-info-circle" aria-hidden="true"></i> 詳細內容
                </button>
              </div>
              <br />
            </div>
            <div class="btn-block">
              <div class="input-group" v-if="!orderList.shopper_black_info && !isGuest">
                <button class="btn btn-danger m-r-5 m-y-5" data-toggle="modal" data-target="#blackModal">
                  標記黑名單
                </button>
                <br />
              </div>
              <div v-if="orderList.shopper_black_info">
                <div>
                  <div class="input-group">
                    <span class="input-group-addon bg-red" style="border: 1px solid #dd4b39">
                      黑名單原因
                    </span>
                    <div class="form-control form-info">
                      {{getBReasonText(orderList.shopper_black_info.reason_type_id)}}
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon bg-red" style="border: 1px solid #dd4b39">
                      黑名單狀態
                    </span>
                    <div class="form-control form-info">
                      {{getBStatusText(orderList.shopper_black_info.status)}}
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div class="box-body form-right p-l-0">
            <span class="hidden-xs hidden-sm"><br /></span>
            <div>
              <div class="input-group ">
                <span class="input-group-addon">品牌名稱(ID)</span>
                <div class="form-control form-info">
                  {{orderList.brand_name}}({{orderList.brand_id}})
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">分店(ID)</span>
                <div class="form-control form-info">
                  <a target="_blank" :href="'https://order.nidin.shop/menu/' + orderList.store_id">
                    {{orderList.store_name}}({{orderList.store_id}})
                  </a>
                </div>
              </div>
              <br />
            </div>
            <div class="visible-xs-block">
              <div class="input-group">
                <span class="input-group-addon">
                  下訂時間
                </span>
                <div class="form-control form-info">
                  {{orderList.order_time?orderList.order_time:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  付款狀態
                </span>
                <div class="form-control form-info">
                  {{payStateName(orderList.payment_status)?payStateName(orderList.payment_status):'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  總份數
                </span>
                <div class="form-control form-info">
                  {{orderList.total_amount}} 份
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  金額計算
                </span>
                <div class="form-control form-info">
                  <p class="text-pay-list m-y-5 c-pointer">
                    &nbsp;商品 x {{orderList.total_amount}}
                    <span class="pull-right"> ＄{{orderList.total_money}}</span>
                  </p>
                  <p class="text-pay-list m-y-5" v-if="orderList.shipping_money">
                    &nbsp;運費
                    <span class="pull-right"> ＄{{orderList.shipping_money}}</span>
                  </p>
                  <p class="text-pay-list m-y-5" v-if="orderList.service_money">
                    &nbsp;服務費
                    <span class="pull-right">＄{{orderList.service_money}}</span>
                  </p>
                  <p class="text-pay-list m-y-5" v-for="payment in orderList.payment_list" v-if="payment.method === 5 || payment.method === 31 || payment.method === 41">
                    &nbsp;{{ payment.method === 31 ? '優惠券' : payment.method === 41 ? '電子票券' : payment.name }}
                    <button v-if="payment.method === 31 || payment.method === 41" class="btn btn-default btn-sm m-l-5" @click="payment.method === 31?showCouponModal=true:showVoucherModal=true">查看</button>
                    <span class="pull-right text-red">- ＄{{payment.money}}</span>
                  </p>

                  <!-- 線下優惠券 -->
                  <p v-if="isOffline && combineCouponList.length" class="text-pay-list m-y-5">
                    &nbsp;優惠券
                    <button class="btn btn-default btn-sm m-l-5" @click="showOfflineCouponModal = true">查看</button>
                    <span class="pull-right text-red">- ＄{{totalOfflineCouponMoney}}</span>
                  </p>
                  <!-- End 線下優惠券 -->

                  <!-- 線下電子票券 -->
                  <p v-if="isOffline && combineVoucherList.length" class="text-pay-list m-y-5">
                    &nbsp;電子票券
                    <button class="btn btn-default btn-sm m-l-5" @click="showOfflineVoucherModal = true">查看</button>
                    <span class="pull-right text-red">- ＄{{totalOfflineVoucherMoney}}</span>
                  </p>
                  <!-- End 線下電子票券 -->

                  <p class="text-pay-list m-y-5" v-if="orderList.discount && orderList.discount.total_discount">
                    &nbsp;店家優惠
                    <button data-toggle="modal" data-target="#discountDetailModal" class="btn btn-default btn-sm m-l-5">查看</button>
                    <span class="pull-right text-red">- ＄{{orderList.discount.total_discount}}</span>
                  </p>
                  <p class="text-pay-list m-y-5" v-if=" orderList.point && orderList.point.payment && orderList.point.payment.total_money">
                  <div v-for="(p, index) in orderList.point?orderList.point.payment.list:[]" :key="index">
                    &nbsp;點數
                    <span class="pull-right text-red">- ＄{{orderList.point.payment.total_money}}</span>
                  </div>
                  <div v-if="orderList.point && orderList.point.payment && orderList.point.payment.list && orderList.point.payment.list.length === 0">
                    &nbsp;點數
                    <span class="pull-right">- ＄0</span>
                  </div>
                  </p>
                  <p class="text-pay-list m-y-5" v-for="payment in orderList.payment_list" v-if="payment.method === 6">
                    &nbsp;自備飲料杯折扣 x {{ payment.total_cup_amount }}
                    <span class="pull-right text-red">- ＄{{payment.money}}</span>
                  </p>
                  <p class="text-pay-list m-y-5" v-if="orderList.membership_discount">
                  <div v-for="(m, index) in membershipDiscount" :key="index">
                    &nbsp;{{ memberCardDiscount | discountText(true) }}
                    <span class="pull-right text-red">- ＄{{m.total_discount}}</span>
                  </div>
                  </p>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  總金額
                </span>
                <div class="form-control form-info">
                  {{orderList.total_paid_money}} 元
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  付款類型
                </span>
                <div class="form-control form-info">
                  {{tradeType(orderList.trade_type)?tradeType(orderList.trade_type):'無資料'}}&nbsp;
                </div>
              </div>
              <br />
            </div>
            <div v-if="roleType === 99 && showTradeInfo">
              <div class="input-group">
                <span class="input-group-addon">
                  交易明細資訊
                </span>
                <button class="btn btn-default" data-target="#refundModal" data-toggle="modal" @click="getTradeInfo">
                  <i class="fa fa-info-circle" aria-hidden="true"></i> 詳細內容
                </button>
              </div>
              <br />
            </div>
            <div v-if="orderList.shopper_remark">
              <div class="input-group">
                <span class="input-group-addon">
                  購物者備註
                </span>
                <div class="form-control form-info">
                  {{ orderList.shopper_remark || '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.store_memo">
              <div class="input-group">
                <span class="input-group-addon">
                  店家備註
                </span>
                <div class="form-control form-info">
                  {{ orderList.store_memo || '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.store_remark">
              <div class="input-group">
                <span class="input-group-addon">
                  店家備註
                </span>
                <div class="form-control form-info">
                  {{ orderList.store_remark || '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.store_memo">
              <div class="input-group">
                <span class="input-group-addon">
                  店家訂單備註
                </span>
                <div class="form-control form-info">
                  {{ orderList.store_memo || '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.settle_time" class="visible-xs-block">
              <div class="input-group">
                <span class="input-group-addon">
                  結帳時間
                </span>
                <div class="form-control form-info">
                  {{orderList.settle_time}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.invoice_type">
              <div class="input-group">
                <span class="input-group-addon">
                  發票類型
                </span>
                <div class="form-control form-info">
                  {{invoiceType(orderList.invoice_type, orderList.email)}}&nbsp;
                  <span v-if="orderList.email">{{orderList.email}}</span>
                  <span v-if="orderList.invoice_type === 20">{{orderList.invoice_carrier_id}}</span>
                  <span v-else-if="orderList.invoice_type === 30">{{orderList.invoice_npoban_name}} ({{orderList.invoice_npoban}})</span>
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isGuest">
              <div class="input-group">
                <span class="input-group-addon">
                  發票號碼
                </span>
                <div class="form-control form-info">
                  {{orderList.invoice_no?orderList.invoice_no:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="orderList.invoice_issue_time" class="visible-xs-block">
              <div class="input-group">
                <span class="input-group-addon">
                  開立發票時間
                </span>
                <div class="form-control form-info">
                  {{orderList.invoice_issue_time}}
                </div>
              </div>
              <br />
            </div>
            <!-- 不是訪客 且 不是線下訂單，顯示「統一編號」欄位 -->
            <div v-if="!isGuest && !isOffline">
              <div class="input-group">
                <span class="input-group-addon">
                  統一編號
                </span>
                <div class="form-control form-info">
                  {{ orderList.ein || '無資料' }}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  更新時間
                </span>
                <div class="form-control form-info">
                  {{orderList.update_time?orderList.update_time:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isGuest" class="visible-xs-block">
              <div class="input-group">
                <span class="input-group-addon">
                  建立時間
                </span>
                <div class="form-control form-info">
                  {{orderList.create_time?orderList.create_time:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isGuest">
              <div class="input-group">
                <span class="input-group-addon">
                  POS機訂單編號
                </span>
                <div class="form-control form-info">
                  {{orderList.pos_order_sn?orderList.pos_order_sn:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  收銀機(櫃檯代號)
                </span>
                <div class="form-control form-info">
                  {{orderList.pos_cashier_no?orderList.pos_cashier_no:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  POS機當日交易序號
                </span>
                <div class="form-control form-info">
                  {{orderList.pos_order_no?orderList.pos_order_no:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="!isGuest">
              <div class="input-group">
                <span class="input-group-addon">
                  POS機取餐號碼
                </span>
                <div class="form-control form-info">
                  {{orderList.pos_take_no?orderList.pos_take_no:'無資料'}}
                </div>
              </div>
              <br />
            </div>
            <div class="btn-block" v-if="roleType === 99 && (orderList.status == 3 || orderList.status == 100 || orderList.status == 2 || orderList.status == 1 || orderList.status == 100 || orderList.status == 110 || orderList.status == 120 || orderList.status == 122 || orderList.status == 130 || orderList.status == 140)">
              <div class="input-group">
                <button class="btn btn-danger m-r-5 m-y-5" v-if="orderList.status == 3 || orderList.status == 100" data-toggle="modal" data-target="#resendOrderNotifyModal">
                  重新發送通知給店家
                </button>
                <button class="btn btn-danger m-r-5 m-y-5" v-if="orderList.status == 2 || orderList.status == 3" data-toggle="modal" data-target="#refundOrderModal">
                  訂單退款
                </button>
                <button class="btn btn-danger m-r-5 m-y-5" v-if="orderList.status == 1 || orderList.status == 2 || orderList.status == 3" data-toggle="modal" data-target="#cancelShopperOrderModal">
                  取消訂購者訂單
                </button>
                <br />
              </div>
            </div>
          </div>
          <!-- 物流 -->
          <div class="box-body form-center text-center" v-if="bindingShipping">
            <hr>
          </div>

          <div class="box-body form-left p-l-10 p-r-10-p" v-if="bindingShipping">
            <!-- <div v-if="bindingShipping.status >= 100">
              <div class="input-group">
                <span class="input-group-addon">
                  叫件狀態
                </span>
                <div class="form-control form-info">
                  <div class="status-light inline-block" :class="shippingStateColor(bindingShipping.status)"></div>
                  <div class="inline-block" style="line-height: 23px">&nbsp;{{shippingState(bindingShipping.status)}}({{bindingShipping.status}})&nbsp;</div>
                </div>
              </div>
              <br />
            </div> -->

            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  報價狀態
                </span>
                <div class="form-control form-info">
                  <div class="inline-block" style="line-height: 23px">&nbsp;{{quotedState(bindingShipping.quoted_status)}}({{bindingShipping.quoted_status}})&nbsp;</div>
                </div>
              </div>
              <br />
            </div>

            <div v-if="bindingShipping.status_reason">
              <div class="input-group">
                <span class="input-group-addon">
                  叫件失敗原因
                </span>
                <div class="form-control form-info">
                  <div class="inline-block" style="line-height: 23px">
                    {{ bindingShipping.status_reason }}
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  預計取件時間
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.expected_get_time}}
                </div>
              </div>
              <br />
            </div>

            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  預計送達時間
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.expected_arrived_time}}
                </div>
              </div>
              <br />
            </div>

            <div v-if="bindingShipping.advance_money">
              <div class="input-group">
                <span class="input-group-addon">
                  代收貨款費
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.advance_money}} 元
                </div>
              </div>
              <br />
            </div>

            <div v-if="bindingShipping.vendor_fee_remark">
              <div class="input-group">
                <span class="input-group-addon">
                  手續費
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.vendor_fee_remark}}
                </div>
              </div>
              <br />
            </div>
          </div>

          <div class="box-body form-right p-l-0" v-if="bindingShipping">

            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  物流業者
                </span>
                <div class="form-control form-info">
                  {{ bindingShipping.vendor_code | shippingVendorName }}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  物流預估距離
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.distance}} 公尺
                </div>
              </div>
              <br />
            </div>
            <div v-if="bindingShipping.weight">
              <div class="input-group">
                <span class="input-group-addon">
                  物流預估重量
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.weight}} 公克
                </div>
              </div>
              <br />
            </div>

            <!-- 預估運費報價: 僅全球顯示 -->
            <div v-if="bindingShipping.vendor_code && bindingShipping.vendor_code == 'glo'">
              <div class="input-group">
                <span class="input-group-addon">
                  預估運費報價
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.total_fee}} 元
                </div>
              </div>
              <br />
            </div>
            <!-- 預估外送員運費: 僅米特顯示 -->
            <div v-if="bindingShipping.vendor_code && bindingShipping.vendor_code.includes('mete')">
              <div class="input-group">
                <span class="input-group-addon">
                  預估外送員運費
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.total_fee}} 元 / 位
                </div>
              </div>
              <br />
            </div>

            <!-- <div v-if="bindingShipping.customer_order_no">
              <div class="input-group">
                <span class="input-group-addon">
                  物流查詢單號
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.customer_order_no}}
                </div>
              </div>
              <br />
            </div> -->

            <div v-if="bindingShipping.vendor_quoted_no">
              <div class="input-group">
                <span class="input-group-addon">
                  物流報價單號
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.vendor_quoted_no}}
                </div>
              </div>
              <br />
            </div>

            <div v-if="bindingShipping.driver_amount">
              <div class="input-group">
                <span class="input-group-addon">
                  外送員人數
                </span>
                <div class="form-control form-info">
                  {{ bindingShipping.driver_amount }} 位
                </div>
              </div>
              <br />
            </div>

            <div v-if="bindingShipping.remark">
              <div class="input-group">
                <span class="input-group-addon">
                  叫件備註
                </span>
                <div class="form-control form-info">
                  {{bindingShipping.remark}}
                </div>
              </div>
              <br />
            </div>
          </div>

          <br style="clear: both">
          <!-- 外送員資訊 -->
          <div class="col-xs-12 hint" v-if="bindingShipping && bindingShipping.status >= 100 && bindingShipping.vendor_code != 'glo'">
            系統將會優先媒合外送員1，若其餘外送員長時間顯示無資料，請聯絡物流客服。
          </div>
          <div class="w-100 box-body" v-if="bindingShipping">
            <table class="table table-bordered table-striped dataTable no-footer">
              <thead>
                <tr>
                  <th>外送員編號</th>
                  <th>外送員(代碼)</th>
                  <th>外送員電話</th>
                  <th>物流廠商</th>
                  <th>物流查詢編號</th>
                  <th>實際取貨時間</th>
                  <th>實際送達時間</th>
                  <th>運費(元)</th>
                  <th>物流狀態</th>
                  <th>物流時間狀態</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="bindingShipping.status < 100">
                  <td colspan="10" style="text-align: center;">尚未叫件</td>
                </tr>
                <template v-else>
                  <tr v-for="(item, index) in shippingCaseList" :key="index">
                    <td>外送員{{index + 1}}</td>
                    <td>{{item.driver_name || '-'}}<span v-if="item.driver_code">({{ item.driver_code }})</span> </td>
                    <td>{{item.driver_phone || '-'}}</td>
                    <td>{{item.delivery_platform_name || '-'}}</td>
                    <td>{{item.customer_order_no || '-'}}</td>
                    <td>{{item.actual_get_time || '-'}}</td>
                    <td>{{item.actual_arrived_time || '-'}}</td>
                    <td>{{item.total_fee || '-'}}</td>
                    <td>
                      <label class="label" :class="shippingStateColor(item.status)">{{item.status | shippingStatusName }}</label>
                    </td>
                    <td>
                      <a v-if="item.customer_order_no" @click="driverTimeDialog = item" data-target="#driverTimeModal" data-toggle="modal">查看時間狀態</a>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <!-- End 外送員資訊 -->

          <!-- 評價 -->
          <div class="box-body form-center text-center" v-if="ratingList.length">
            <hr>
            <div class="col-xs-12 table-responsive p-x-0">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">星級</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">留言</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">回覆</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  </tr>
                </thead>
                <tbody v-if="ratingList">
                  <tr class="even" role="row" v-for="(rating, index) in ratingList">
                    <td class="sorting_1"><span class="text-danger text-bold" v-if="rating.is_main"><i class="fa fa-fire" aria-hidden="true"></i> 最新</span></td>
                    <td :class="rating.star > 3 ? 'text-success' : 'text-danger'"><i class="fa fa-star" aria-hidden="true"></i>&nbsp;{{rating.star}}</td>
                    <td>{{rating.comment}}</td>
                    <td>{{rating.reply_comment}}</td>
                    <td>
                      <button class="btn btn-default" :class="{'btn-success': !rating.is_replied}" data-toggle="modal" data-target="#ratingModal" @click="openModal(rating)" v-if="rating.is_main">
                        <span v-if="rating.is_replied">修改</span><span v-else>回覆</span>評價
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="openModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">會員暱稱</span>
                  <div class="form-control form-info text-left">
                    <span v-if="orderList.shopper_black_info"><label class="label label-danger">黑名單</label>&nbsp;</span>
                    {{orderList.shopper_nickname}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">會員手機</span>
                  <div class="form-control form-info text-left">{{orderList.shopper_phone}}</div>
                </div>
                <br />
              </div>
              <div v-if="roleType === 99">
                <div class="input-group">
                  <span class="input-group-addon">會員信箱</span>
                  <div class="form-control form-info text-left">{{orderList.shopper_email}}</div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="blackOption" :selectOptions="bSelectOptions" @trigger="trigger" @selectOnChange="changeBlackReason"></m-modal>
    <m-modal :option="resendOrderNotifyOption" @trigger="trigger"></m-modal>
    <m-modal :option="refundOrderOption" @trigger="trigger"></m-modal>
    <m-modal :option="cancelShopperOrderOption" @trigger="trigger"></m-modal>
    <m-modal :option="cancelPosOrderOption" @trigger="trigger"></m-modal>
    <m-modal :option="editOrderStateOption" :selectOptions="selectOptions" @trigger="trigger" @selectOnChange="selectOnChange" @inputOnChange="inputOnChange"></m-modal>
    <m-modal :option="forceRefundOption" @trigger="trigger"></m-modal>
    <div class="modal fade" role="dialog" id="refundModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="box-body form text-left">
            <pre id="trade-info"></pre>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="discountDetailModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">店家優惠</h4>
          </div>
          <div v-if="orderList.discount" class="modal-body">
            <div class="row">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <tbody>
                      <tr>
                        <td colspan="3" class="sorting_1 v-middle text-left bg-dark-gray text-white">
                          <span class="pull-right">
                            -${{ orderList.discount.total_discount }}
                          </span>
                        </td>
                      </tr>
                      <tr v-for="(discount, i) in orderList.discount.list" :key="`product-${i}`" role="row">
                        <td class="sorting_1 v-middle text-center">
                          {{ i + 1 }}
                        </td>
                        <td class="v-middle">
                          <div v-if="discount.activity_name">
                            ◎活動名稱：{{ discount.activity_name }}
                          </div>
                          <div v-if="discount.start_date && discount.end_date">
                            ◎活動時間：{{ discount.start_date }} ~ {{ discount.end_date }}
                          </div>
                          <div v-if="discount.activity_description">
                            ◎活動說明：{{ discount.activity_description }}
                          </div>
                          <div>
                            ◎折扣碼：{{ discount.exchange_code || '無' }}
                          </div>
                        </td>
                        <td class="text-right">-${{ discount.total_discount }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 產品內容-產品明細彈窗 -->
    <div class="modal fade" role="dialog" id="orderDetailModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">產品明細</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="row">
                <div class="flex justify-end">
                </div>
                <!-- 團長訂購內容 -->
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <tbody>
                      <!-- 抬頭 -->
                      <tr>
                        <td :colspan="productCouponList.length || productVoucherList.length ? 4 : 3" class="sorting_1 v-middle text-left bg-dark-gray text-white">
                          {{ orderList.name }}
                          <span class="pull-right">
                            ＄{{ orderList.money }}
                            <span class="c-pointer" v-if="productCouponList.length || productVoucherList.length" data-toggle="modal" data-target="#couponModal" @click="info = orderList; showCouponVoucherModal=true">
                              <i class="fa fa-ticket text-red" aria-hidden="true" />
                            </span>
                          </span>
                        </td>
                      </tr>
                      <tr v-for="(p, i) in productList" :key="`product-${i}`" role="row">
                        <td class="sorting_1 v-middle text-center">
                          {{ i + 1 }}
                        </td>
                        <!-- 商品內容欄位 -->
                        <td class="flex row">
                          <div>
                            <h4>
                              {{ p.product }} - ＄{{ p.total_money / p.amount }}
                            </h4>
                            <p class="product-option">
                              <span v-if="p.type === 1" v-for="(option, j) in p.option_list" :key="`option-${j}`">
                                {{ option }}
                                <span v-if="j < p.option_list.length - 1"> / </span>
                              </span>
                              <span v-if="p.type === 3" v-for="(pList, k) in p.product_list" :key="`pList-${k}`">
                                <span v-for="(prod, l) in pList" :key="`prod-${l}`">
                                  <span>
                                    {{ prod.product }}
                                  </span>
                                  <span v-if="prod.amount > 1">
                                    x{{ prod.amount }}
                                  </span>
                                  <span v-if="prod.type === 1" v-for="(opt, m) in prod.option_list" :key="`opt-${m}`">
                                    <span v-if="m === 0">：</span>
                                    {{ opt }}
                                    <span v-if="m < prod.option_list.length - 1"> / </span>
                                  </span>
                                  <br>
                                </span>
                              </span>
                            </p>
                            <!-- 自備杯折扣 -->
                            <p class="flex" v-if="p.cup_amount">
                              <img src="../../../assets/icon/i_reusable_cup_black.svg" />
                                <span class="product-option p-l-5">自備飲料杯 x{{ p.cup_amount }}</span>
                            </p>
                            <p v-if="p.sticker_name">
                              <span>
                                <i class="fa fa-user" aria-hidden="true" />
                                {{ p.sticker_name }}
                              </span>
                            </p>
                            <p v-if="p.custom_remark">
                              <i class="fa fa-quote-left" aria-hidden="true" />
                              {{ p.custom_remark }}
                            </p>
                          </div>
                          <div v-if="p.amount" class="m-l-auto">
                            <h4 class="text-right text-bold text-nowrap">x {{ p.amount }}</h4>
                          </div>
                        </td>
                        <!-- End 商品內容欄位 -->
                        <td v-if="!productCouponList.length || !productVoucherList.length">
                          <h4 class="text-right text-bold text-nowrap">${{p.total_money}}</h4>
                        </td>
                        <td v-if="productCouponList.length || productVoucherList.length">
                          <h4 class="text-right text-bold">${{p.total_money}}</h4>
                          <!-- 優惠券 -->
                          <div v-if="productCouponMap[p.item_set_uid]" class="flex align-center justify-between">
                            <label class="label label-default bg-blue mb-0">優惠券</label>
                            <span class="product-option"> -${{productCouponMap[p.item_set_uid].total_discount}}</span>
                          </div>
                          <!-- End 優惠券 -->

                          <!-- 電子票券 -->
                          <div v-if="productVoucherMap[p.item_set_uid]" class="flex align-center justify-between">
                            <label class="label label-default bg-blue mb-0">電子票券</label>
                            <span class="product-option"> -${{productVoucherMap[p.item_set_uid].total_discount}}</span>
                          </div>
                          <!-- End 電子票券 -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- 團員訂購內容 -->
                <div class="col-sm-12 table-responsive p-x-0" v-if="orderList.order_type === 2" v-for="(follower, i) in orderList.group_buy_follower_order_list" :key="`follower-${i}`">
                  <table aria-describedby="example1_info" role="grid" id="example2" class="table table-bordered table-striped dataTable">
                    <tbody>
                      <tr>
                        <td :colspan="follower.coupon_list.length || follower.voucher_list.length ? 4:3" class="sorting_1 text-left bg-dark-gray text-white">
                          {{ follower.contact_name }}
                          <span v-if="follower.is_guest_order === 1">（非會員）</span>
                          <span class="pull-right">
                            ＄{{follower.money}}
                            <span class="c-pointer" v-if="follower.coupon_list.length || follower.voucher_list.length" data-toggle="modal" data-target="#couponModal" @click="info = follower; showCouponVoucherModal=true">
                              <i class="fa fa-ticket text-red" aria-hidden="true" />
                            </span>
                          </span>
                        </td>
                      </tr>
                      <tr role="row" v-for="(p, index) in follower.product_list">
                        <td class="sorting_1 text-center">{{index + 1}}</td>
                        <td>
                          <h4>{{p.product}} - ＄{{p.total_money / p.amount}}</h4>
                          <p class="product-option">
                            <span v-if="p.type === 1" v-for="(option, index) in p.option_list">
                              {{option}} <span v-if="index < p.option_list.length - 1"> / </span>
                            </span>
                            <span v-if="p.type === 3" v-for="pList in p.product_list">
                              <span v-for="prod in pList">
                                <span>{{prod.product}}</span><span v-if="prod.amount > 1">x{{prod.amount}}</span><span v-if="prod.type === 1" v-for="(opt, i) in prod.option_list">
                                  <span v-if="i === 0">：</span>{{opt}}<span v-if="i < prod.option_list.length - 1"> / </span>
                                </span>
                                <br>
                              </span>
                            </span>
                          </p>
                          <!-- 自備杯折扣 -->
                          <p class="flex" v-if="p.cup_amount">
                            <img src="../../../assets/icon/i_reusable_cup_black.svg" />
                              <span class="product-option p-l-5">自備飲料杯 x{{ p.cup_amount }}</span>
                          </p>
                          <p v-if="p.sticker_name">
                            <span>
                              <i class="fa fa-user" aria-hidden="true"></i>
                              {{p.sticker_name}}
                            </span>
                          </p>
                        </td>
                        <td>
                          <h4 class="text-right text-bold text-nowrap">x {{ p.amount }}</h4>
                        </td>
                        <td v-if="follower.coupon_list.length || follower.voucher_list.length">
                          <h4 class="text-right text-bold">${{p.total_money}}</h4>
                          <!-- 優惠券 -->
                          <div v-if="follower.product_coupon_list.item_list && follower.product_coupon_list.item_list[p.item_set_uid]" class="flex align-center justify-between">
                            <label class="label label-default bg-blue mb-0">優惠券</label>
                            <span class="product-option"> -${{follower.product_coupon_list.item_list[p.item_set_uid].total_discount}}</span>
                          </div>
                          <!-- End 優惠券 -->

                          <!-- 電子票券 -->
                          <div v-if="follower.product_voucher_list.item_list && follower.product_voucher_list.item_list[p.item_set_uid]" class="flex align-center justify-between">
                            <label class="label label-default bg-blue mb-0">電子票券</label>
                            <span class="product-option"> -${{follower.product_voucher_list.item_list[p.item_set_uid].total_discount}}</span>
                          </div>
                          <!-- End 電子票券 -->
                        </td>
                      </tr>
                      <!--
                      <tr>
                        <td colspan="3" class="sorting_1 v-middle text-left">
                          <p class="text-pay-list m-y-5">
                            <i class="fa fa-cutlery" aria-hidden="true"></i>
                            &nbsp;商品 x{{follower.amount}}
                            <span class="pull-right">＄{{follower.money}}</span>
                          </p>
                          <p class="text-pay-list m-y-5 c-pointer" v-for="coupon in follower.coupon_list" v-if="follower.coupon_list.length" data-toggle="modal" data-target="#couponModal" @click="info = follower">
                            <i class="fa fa-ticket" aria-hidden="true"></i>
                            &nbsp;{{coupon.name}}  <i class="fa fa-caret-right" aria-hidden="true"></i>
                            <span class="pull-right text-red">- ＄{{coupon.money}}</span>
                          </p>
                        </td>
                      </tr>
                      -->
                    </tbody>
                    <br>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="couponDetailModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">優惠券明細</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                      <!--
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">品名</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">數量</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">金額</th>
                    </tr>
                    -->
                    </thead>
                    <tbody>
                      <tr role="row" v-for="(c, cIndex) in couponList">
                        <td class="sorting_1 v-middle text-center">{{cIndex + 1}}</td>
                        <td class="v-middle">
                          <h4>{{c.name}} - {{c.coupon_set_code}}</h4>
                          <p class="product-option">
                            <span>
                              {{priceTypeName(c.price_type)}}
                            </span>
                          </p>
                        </td>
                        <td class="v-middle text-right">x {{c.amount}}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="text-right bg-dark-gray text-white">
                        <td rowspan="3" class="text-w-600">$ {{totalCouponMoney}}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="getCouponDetailModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">獲得優惠券明細</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                      <!--
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">品名</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">數量</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">金額</th>
                    </tr>
                    -->
                    </thead>
                    <tbody>
                      <tr role="row" v-for="(c, cIndex) in getCouponList">
                        <td class="sorting_1 v-middle text-center">{{cIndex + 1}}</td>
                        <td class="v-middle">
                          <h4>{{c.name}} - {{c.coupon_set_code}}</h4>
                          <p class="product-option">
                            <span>
                              {{priceTypeName(c.price_type)}}
                            </span>
                          </p>
                        </td>
                        <td class="v-middle">
                          {{valueName(c.discount_value, c.discount_type)}}
                        </td>
                        <td class="v-middle text-right">x {{c.amount}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="getPointDetailModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">獲得點數/積分明細</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <!-- 獲得點數 Table -->
                  <table
                    aria-describedby="example1_info"
                    role="grid" id="example1"
                    class="table table-bordered table-striped"
                  >
                    <tbody>
                      <!-- 抬頭 -->
                      <tr v-if="Object.keys(groupedPoints).length">
                        <td
                          colspan="4"
                          class="sorting_1 v-middle text-left bg-dark-gray text-white"
                        >
                          獲得點數
                        </td>
                      </tr>
                      <tr v-for="(group, src_type, index) in groupedPoints" :key="src_type">
                        <td
                          v-if="group.length"
                          rowspan="group.length"
                          class="text-center vertical-m"
                        >
                          {{ index+1 }}
                        </td>
                        <td
                          v-if="group.length"
                          rowspan="group.length"
                          class="vertical-m"
                          width="150px"
                        >
                          {{ getSrcTypeName('point', src_type) }}
                        </td>
                        <td
                          class="p-0"
                          rowspan="group.length"
                        >
                          <div
                            v-for="(point, index) in group"
                            :key="point.point_id"
                            class="dialog-border"
                          >
                            <!-- {{ point.point_name }} -->
                              {{point.point_brand_name ? point.point_brand_name : '你訂'}}{{point.point_store_name? point.point_store_name : ''}}點數
                          </div>
                        </td>
                        <td
                          class="p-0"
                          rowspan="group.length"
                        >
                          <div
                            v-for="(point, index) in group"
                            :key="point.point_id"
                            class="flex dialog-border justify-end"
                          >{{ point.amount }} (點)</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 獲得積分 Table -->
                  <table
                    aria-describedby="example1_info"
                    role="grid"
                    id="example1"
                    class="table table-bordered table-striped"
                  >
                    <tbody>
                      <!-- 抬頭 -->
                      <tr v-if="Object.keys(groupedMembershipScore).length">
                        <td
                          colspan="4"
                          class="sorting_1 v-middle text-left bg-dark-gray text-white"
                        >
                          獲得積分
                        </td>
                      </tr>
                      <tr v-for="(group, src_type, index) in groupedMembershipScore" :key="src_type">
                        <td
                          v-if="group.length"
                          rowspan="group.length"
                          class="text-center vertical-m"
                        >
                          {{ index+1 }}
                        </td>
                        <td
                          v-if="group.length"
                          rowspan="group.length"
                          class="vertical-m"
                          width="150px"
                        >
                          {{ getSrcTypeName('memberScore', src_type) }}
                        </td>
                        <td
                          class="p-0"
                          rowspan="group.length"
                        >
                          <div
                            v-for="(item, index) in group"
                            :key="'s_' + index"
                            class="dialog-border"
                          >
                          {{ item.membership_group_brand_name ? item.membership_group_brand_name :'你訂'}}{{ item.membership_group_store_name ? item.membership_group_store_name :''}}積分
                        </div>
                        </td>
                        <td
                          rowspan="group.length"
                          class="p-0"
                        >
                          <div
                            v-for="(item, index) in group"
                            :key="item.point_id"
                            class="flex dialog-border justify-end"
                          >{{ item.amount }} (積分)</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="statusTrackingModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">訂單狀態紀錄</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody>
                    <tr class="even" role="row" v-for="(tracking, index) in orderList.status_tracking">
                      <td>
                        {{tracking.create_time}}
                      </td>
                      <td>
                        {{orderState(tracking.status)}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="notifyHistoryModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">門市通知紀錄</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody>
                    <tr class="even" role="row" v-for="(history, index) in orderList.notify_history">
                      <td>
                        {{history.create_time}}
                      </td>
                      <td>
                        {{notifyType(history.type)}}
                      </td>
                      <td>
                        <span v-if="history.is_notified" class="label label-success">已發送</span>
                        <span v-if="!history.is_notified" class="label label-danger">未發送</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="allowanceModal" role="dialog">
      <div class="modal-dialog text-left">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">商品優惠</h4>
          </div>
          <div class="modal-body">
            <p v-for="(allowance, aIndex) in orderList.allowance">
              {{aIndex + 1}}.&nbsp;&nbsp;購買<span v-for="(prod, pIndex) in allowance.menu_name_group">{{prod}}<span v-if="pIndex + 1 < allowance.menu_name_group.length">、</span></span>折{{allowance.total_allowance/allowance.match_amount}}元
              &nbsp;<span class="label label-primary" style="top: -2px">符合 {{allowance.match_amount}} 組</span>，<span class="label label-danger" style="top: -2px">共折 {{allowance.total_allowance}} 元</span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="driverTimeModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">物流狀態時間</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody v-if="driverTimeDialog">
                    <tr class="even" role="row" v-if="driverTimeDialog.create_time">
                      <td>{{driverTimeDialog.create_time}}</td>
                      <td>成立物流單</td>
                    </tr>
                    <tr class="even" role="row" v-if="driverTimeDialog.vendor_confirm_time">
                      <td>{{driverTimeDialog.vendor_confirm_time}}</td>
                      <td>物流接單</td>
                    </tr>
                    <tr class="even" role="row" v-if="driverTimeDialog.store_cancel_time">
                      <td>{{driverTimeDialog.store_cancel_time}}</td>
                      <td>門市取消叫件</td>
                    </tr>
                    <tr class="even" role="row" v-if="driverTimeDialog.vendor_cancel_time && driverTimeDialog.status != 900">
                      <td>{{driverTimeDialog.vendor_cancel_time}}</td>
                      <td>媒合失敗</td>
                    </tr>
                    <tr class="even" role="row" v-if="driverTimeDialog.actual_get_time">
                      <td>{{driverTimeDialog.actual_get_time}}</td>
                      <td>已取貨</td>
                    </tr>
                    <tr class="even" role="row" v-if="driverTimeDialog.actual_arrived_time">
                      <td>{{driverTimeDialog.actual_arrived_time}}</td>
                      <td>已送達</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="ratingModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title"><span v-if="ratingInfo.is_replied">修改</span><span v-else>回覆</span>評價</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <p>{{ratingInfo.comment}}</p>
                <p class="text-right"><small>{{ratingInfo.create_time}}</small></p>
                <!-- <hr> -->
                <div class="m-t-10">
                  <textarea class="w-100-p p-10" style="min-height: 250px" v-model="ratingInfo.reply_comment"></textarea>
                </div>
                <p class="text-right"><small>{{ratingInfo.reply_time}}</small></p>
              </div>
            </div>
            <div class="row">
              <button type="button" class="btn btn-default" @click="defaultComment(1)">感謝支持</button>
              <button type="button" class="btn btn-default" @click="defaultComment(2)">抱歉</button>
              <button type="button" class="btn btn-default" @click="defaultComment(3)">已聯絡</button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="reply" data-dismiss="modal">確定<span v-if="ratingInfo.is_replied">修改</span><span v-else>回覆</span></button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showCouponVoucherModal" class="modal fade in" style="display: block;">
      <div class="modal-content coupon-modal">
        <div class="modal-header">
          <button type="button" class="close" @click.prevent="showCouponVoucherModal=false">&times;</button>
          <h4 class="modal-title">詳情</h4>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 400px;">
          <template v-if="info.coupon_list && info.coupon_list.length">
            <h5 class="text-bold ">優惠券</h5>
            <ol>
              <template v-for="(productCoupon) in infoProductCouponFormat">
                <li class="mb-2" v-for="(coupon) in productCoupon.formatList">
                  <div class="d-flex align-center">
                    <span class="label label-default mb-0">{{coupon.productName}}</span>
                    <span class="m-l-5">使用</span>
                    <span class="label label-primary m-l-5 mb-0">{{ coupon.count }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.count * coupon.unitDiscount }}元</span>
                  </div>
                </li>
              </template>
              <li class="mb-2" v-for="(coupon) in info.coupon_list.filter(i => !i.product_name)">
                <div class="d-flex align-center">
                  <span class="label label-default mb-0">{{coupon.product_name}}</span>
                  <span class="m-l-5">使用</span>
                  <span class="label label-primary m-l-5 mb-0">{{ coupon.amount }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.money }}元</span>
                </div>
              </li>
            </ol>
          </template>
          <hr v-if="info.coupon_list && info.coupon_list.length && info.voucher_list && info.voucher_list.length" style="margin: 1.5em 0">
          <template v-if="info.voucher_list && info.voucher_list.length">
            <h5 class="text-bold ">電子票券</h5>
            <ol>
              <template v-for="(VoucherCoupon) in infoVoucherCouponFormat">
                <li class="mb-2" v-for="(coupon) in VoucherCoupon.formatList">
                  <div class="d-flex align-center">
                    <span class="label label-default mb-0">{{coupon.productName}}</span>
                    <span class="m-l-5">使用</span>
                    <span class="label label-primary m-l-5 mb-0">{{ coupon.count }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.count * coupon.unitDiscount }}元</span>
                  </div>
                </li>
              </template>
            </ol>
          </template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click.prevent="showCouponVoucherModal=false">返回</button>
        </div>
      </div>
    </div>
    <div v-if="showCouponModal" class="modal fade in" style="display: block;">
      <div class="modal-content coupon-modal">
        <div class="modal-header">
          <button type="button" class="close" @click.prevent="showCouponModal = false">&times;</button>
          <h4 class="modal-title">優惠券核銷詳情</h4>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 400px;">
          <ol>
            <template v-for="(productCoupon) in productCouponListFormat">
              <li class="mb-2" v-for="(coupon) in productCoupon.formatList">
                <div class="d-flex align-center">
                  <span class="label label-default mb-0">{{coupon.productName}}</span>
                  <span class="m-l-5">使用</span>
                  <span class="label label-primary m-l-5 mb-0">{{ coupon.count }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.count * coupon.unitDiscount }}元</span>
                </div>
              </li>
            </template>
            <template v-for="(gbProductCoupon) in gbProductCouponListFormat">
              <li class="mb-2" v-for="(coupon) in gbProductCoupon.formatList">
                <div class="d-flex align-center">
                  <span class="label label-default mb-0">{{coupon.productName}}</span>
                  <span class="m-l-5">使用</span>
                  <span class="label label-primary m-l-5 mb-0">{{ coupon.count }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.count * coupon.unitDiscount }}元</span>
                </div>
              </li>
            </template>
            <li class="mb-2" v-for="(coupon) in couponListWithoutProduct">
              <div class="d-flex align-center">
                <span class="label label-default mb-0">{{coupon.product_name}}</span>
                <span class="m-l-5">使用</span>
                <span class="label label-primary m-l-5 mb-0">{{ coupon.amount }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.money }}元</span>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div v-if="showVoucherModal" class="modal fade in" style="display: block;">
      <div class="modal-content coupon-modal">
        <div class="modal-header">
          <button type="button" class="close" @click.prevent="showVoucherModal = false">&times;</button>
          <h4 class="modal-title">電子票券核銷詳情</h4>
        </div>
        <div class="modal-body">
          <ol>
            <template v-for="(voucherCoupon) in voucherCouponListFormat">
              <li class="mb-2" v-for="(coupon) in voucherCoupon.formatList">
                <div class="d-flex align-center">
                  <span class="label label-default mb-0">{{coupon.productName}}</span>
                  <span class="m-l-5">使用</span>
                  <span class="label label-primary m-l-5 mb-0">{{ coupon.count }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.count * coupon.unitDiscount }}元</span>
                </div>
              </li>
            </template>
            <template v-for="(gbVoucherCoupon) in gbVoucherCouponListFormat">
              <li class="mb-2" v-for="(coupon) in gbVoucherCoupon.formatList">
                <div class="d-flex align-center">
                  <span class="label label-default mb-0">{{coupon.productName}}</span>
                  <span class="m-l-5">使用</span>
                  <span class="label label-primary m-l-5 mb-0">{{ coupon.count }}張{{ coupon.name }}</span>，<span class="label label-danger mb-0">共折{{ coupon.count * coupon.unitDiscount }}元</span>
                </div>
              </li>
            </template>
            <!-- <li v-for="(voucher) in allVoucherList">
              <div class="d-flex align-center">
                <span class="label label-default mb-0">{{voucher.product_name}}</span>
                <span class="m-l-5">使用</span>
                <span class="label label-primary m-l-5 mb-0">{{ voucher.amount }}張{{ voucher.name }}</span>，<span class="label label-danger mb-0">共折{{ voucher.money }}元</span>
              </div>
            </li> -->
          </ol>
        </div>
      </div>
    </div>

    <div v-if="showProductModal" class="modal fade in" style="display: block;">
      <div class="modal-content product-modal">
        <div class="modal-header">
          <button type="button" class="close" @click="showProductModal=false">&times;</button>
          <h4 class="modal-title">產品優惠券</h4>
        </div>
        <div class="modal-body">
          <p v-for="(product, pIndex) in info.list">
            {{pIndex + 1}}.&nbsp;&nbsp;使用&nbsp;<span class="label label-primary" style="top: -2px">{{product.name}}</span>，<span class="label label-danger" style="top: -2px">共折{{product.unit_discount}}元</span>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="showProductModal=false">返回</button>
        </div>
      </div>
    </div>

  </section>
</template>
<script>
import moment from 'moment'
import matcherModal from '../../elements/Modal.vue'
import { mapGetters } from 'vuex'
import $ from 'jquery'
export default {
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      shippingCaseList: [],
      memberCardDiscount: null,
      isOfflineOrder: false,
      tradeInfo: {},
      roleType: 0,
      bindingShipping: null,
      driverTimeDialog: null,
      ratingList: [],
      ratingInfo: {},
      orderList: {
        notify_history: [],
        allowance: [],
        coupon_list: [],
        voucher_list: [],
        discount: {},
        point: {
          payment: {
            total_money: 0
          }
        },
        membership_discount: {
          total_discount: 0
        }
      },
      info: {
        allowance: [],
        coupon_list: [],
        voucher_list: []
      },
      productList: [],
      couponList: [],
      getCouponList: [],
      voucherList: [],
      getVoucherList: [],
      getPointList: [],
      productCouponList: [], // 優惠券
      productCouponMap: {}, // 優惠券
      productVoucherList: [], // 電子票券
      productVoucherMap: {}, // 電子票券
      selectBlackReason: '',
      bSelectOptions: {
        name: '黑名單原因',
        options: []
      },
      blackOption: {
        id: 'blackModal',
        title: '標註黑名單',
        body: '確定標注使用者為黑名單？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'markBlack'
          }
        ]
      },
      resendOrderNotifyOption: {
        id: 'resendOrderNotifyModal',
        title: '重新發送通知給店家',
        body: '1. 使用者已完成付款，尚未通知店家<br>2. 已通知店家，店家尚未處理<br><br><small>如果狀態為「已付款尚未通知」則會更改訂單狀態為「已通知店家」</small>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'resendOrderNotify'
          }
        ]
      },
      refundOrderOption: {
        id: 'refundOrderModal',
        title: '訂單退款',
        body: '1. 使用者付款中<br>2. 使用者已完成付款，尚未通知店家<br><br><small>將目前還在使用者身上的訂單退款並回復成購物車狀態</small>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'refundOrder'
          }
        ]
      },
      cancelShopperOrderOption: {
        id: 'cancelShopperOrderModal',
        title: '重新發送通知給店家',
        body: '1. 使用者已送出訂單，尚未付款<br>2. 使用者付款中<br>3. 使用者已完成付款，尚未通知店家<br><br><small>後該訂單會被退款，並轉換至「系統已取消」狀態，使用者無法再更新訂單</small>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'cancelShopperOrder'
          }
        ]
      },
      cancelPosOrderOption: {
        id: 'cancelPosOrderModal',
        title: '重新發送通知給店家',
        body: '1. 已通知店家，店家尚未處理<br>2. 店家已接受訂單<br>3. 店家已拒絕訂單<br>4. 店家已取消訂單<br>5. 店家已完成訂單<br>6. 店家已作廢訂單<br><br><small>該訂單會被退款，並轉換至「系統已取消」狀態，使用者與店家皆無法再更新訂單</small>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'cancelPosOrder'
          }
        ]
      },
      forceRefundOption: {
        id: 'forceRefundModal',
        title: '訂單強制退款',
        body: '<span class="text-danger">(危險) 此功能為訂單強制退款，不修改相關狀態！</span><br><br>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'forceRefundOrder'
          }
        ]
      },
      editOrderStateOption: {
        id: 'editOrderStateModal',
        title: '修改訂單狀態',
        body: '<span class="text-danger">(危險) 此功能為強制修改訂單狀態！</span><br><br>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'editOrderState'
          }
        ],
        input: {
          name: '備註'
        }
      },
      selectOptions: {
        name: '訂單狀態',
        options: [
          {text: '請選擇', value: null},
          // {text: '尚未確認(購物車)', value: 0},
          // {text: '已送出，尚未付款', value: 1},
          // {text: '付款中', value: 2},
          // {text: '已完成付款，尚未通知店家', value: 3},
          // {text: '已取消訂單', value: 99},
          // {text: '尚未確認(未接單)', value: 100},
          {text: '已被接受', value: 110},
          {text: '已被店家拒絕', value: 120},
          // {text: '已被系統拒絕', value: 121},
          {text: '已取消', value: 122},
          {text: '已完成', value: 130},
          {text: '已作廢', value: 140}
        ]
      },
      order: {
        newState: null,
        remark: ''
      },
      showCouponVoucherModal: false,
      showCouponModal: false,
      showVoucherModal: false,
      showProductModal: false,
      getMembershipScore: [],
      combineCouponList: [],
      combineVoucherList: []

    }
  },
  filters: {
    discountText: (discount, isMember) => {
      let text = isMember ? '會員卡折扣' : ''

      if (!discount || !discount.discount_value) return text
      text += ' | '

      if (discount.membership_name) text += discount.membership_name

      let price = discount.discount_value
      let percent = Math.round(((100 - price) / 100) * 10)

      switch (discount.discount_type) {
        case 1:
          text += `享全單折抵 ${price} 元`
          break
        case 2:
          text += `享全單 ${percent} 折`
          break
        case 101:
          text += `享商品折抵 ${price} 元`
          break
        case 102:
          text += `享商品 ${percent} 折`
          break
        case 103:
          text += '享商品金額兌換'
          break
        default:
          text += discount.name
          break
      }

      return text
    }
  },
  methods: {
    getMembershipDiscountInfo () {
      let discount = this.membershipDiscount[0]
      let url = `/membership/${discount.membership_id}/discount/${discount.discount_id}/info`
      this.getDataH('get', url, null, (res) => {
        this.memberCardDiscount = res.data.info
        this.memberCardDiscount.membership_name = discount.membership_name
        this.memberCardDiscount.membership_id = discount.membership_id
      })
    },
    orderSource (type) {
      switch (type) {
        case 1:
          return '平台'
        case 2:
          return '專屬'
        case 3:
          return '平台LIFF'
        case 4:
          return '專屬LIFF'
        case 5:
          return '街口支付'
        case 6:
          return '你訂APP'
        default:
          return '其他'
      }
    },
    defaultComment (type) {
      // 1 感謝支持
      // 2 抱歉
      // 3 已聯絡
      if (type === 1) {
        this.ratingInfo.reply_comment = '感謝您的支持與購買！希望下次能再為您服務喔 ^^'
      } else if (type === 2) {
        this.ratingInfo.reply_comment = '抱歉造成您的困擾，我們會再多注意細節的！謝謝您的體諒 ^^'
      } else if (type === 3) {
        this.ratingInfo.reply_comment = '已請客服聯絡，希望能解決您的問題！歡迎再次訂購 ^^'
      }
    },
    reply () {
      if (!this.ratingInfo.reply_comment) {
        this.$notify({
          title: '提醒',
          text: '回覆內容未填！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (this.ratingInfo.is_replied) this.updateReplay()
      else this.createReplay()
    },
    updateReplay () {
      const url = this.replyUrl + this.ratingInfo.rating_id + '/reply'
      const data = {
        comment: this.ratingInfo.reply_comment
      }
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getOrderInfo()
        }
      })
    },
    createReplay () {
      const url = this.replyUrl + this.ratingInfo.rating_id + '/reply'
      const data = {
        comment: this.ratingInfo.reply_comment
      }
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getOrderInfo()
          this.ratingInfo.is_replied = 1
        }
      })
    },
    openModal (rating) {
      const self = this
      const url = this.replyUrl + rating.rating_id + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.ratingInfo = response.data.info
        }
      })
    },
    async getInfo () {
      await this.getOrderInfo()
      // await this.getTradeInfo()
    },
    getTradeInfo () {
      return new Promise((resolve, reject) => {
        var self = this
        var url = '/accounting/orderTradeInfo/' + this.$route.params.order_id
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.tradeInfo = response.data.trade_info
            $('#trade-info').html(JSON.stringify(self.tradeInfo, null, 2))
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    getShortAddress (address) {
      if (!address) return null
      var sAddress = address.split('(')
      return 'https://www.google.com/maps/place/' + sAddress[0]
    },
    /**
     * 優惠券明細
     * @param {Number} value 優惠數值，可以是優惠金額，也可以是優惠折扣
     * @param {Number} type 優惠類型 | 1: 全單折金券 | 2: 全單折價券 | 101: 單品折金券 | 102: 單品折價券 | 103: 贈品券
     */
    valueName (value, type) {
      if (type === 1) return '$' + value // 1: 全單折金券 | 若 value 為 10 表示折抵 10 元
      else if (type === 2) { // 全單折價券 | 若 value 為 0，表示無折扣；若 value 為 5，表示 95 折；若 value 為 20 表示 8 折；若 value 為 90，表示 1 折；若 value 為 99，表示 0.1 折；
        const discount = 100 - value
        if (discount < 0) throw new Error('Type:2 | 全單折價券 | 錯誤的折扣值')
        const discountStr = discount < 10 ? '0.' + discount : discount.toString()
        let result
        if (value === 0) result = '無折扣'
        else if (discountStr.length === 2 && discountStr.endsWith('0')) result = discountStr[0] + '折'
        else result = discountStr + '折'
        return result
      } else if (type === 101) return '$' + value // 單品折金券 | 若 value 為 10 表示折10元
      else if (type === 102) { // 單品折價券 | 若 value 為 0，表示無折扣；若 value 為 5，表示 95 折；若 value 為 20 表示 8 折；
        const discount = 100 - value
        if (discount < 0) throw new Error('Type:102 | 單品折價券 | 錯誤的折扣值')
        const discountStr = discount < 10 ? '0.' + discount : discount.toString()
        let result
        if (value === 0) result = '無折扣'
        else if (discountStr.length === 2 && discountStr.endsWith('0')) result = discountStr[0] + '折'
        else result = discountStr + '折'
        return result
      } else if (type === 103) return '-' // 贈品券
      else return '-'
    },
    trigger (event) {
      // console.log(event)
      if (event === 'resendOrderNotify') {
        this.resendOrderNotify()
      } else if (event === 'refundOrder') {
        this.refundOrder()
      } else if (event === 'cancelShopperOrder') {
        this.cancelShopperOrder()
      } else if (event === 'cancelPosOrder') {
        this.cancelPosOrder()
      } else if (event === 'editOrderState') {
        this.editOrderState()
      } else if (event === 'forceRefundOrder') {
        this.forceRefundOrder()
      } else if (event === 'markBlack') {
        this.markBlack()
      }
    },
    getBReasonText (id) {
      var reason = this.getBlackReason.find(function (o) { return o.reason_type_id === id })
      if (reason) return reason.reason
      return '其他原因'
    },
    getBStatusText (type) {
      if (type === 0) {
        return '無狀態'
      } else if (type === 9) {
        return '尚未確認'
      } else if (type === 10) {
        return '門市確認'
      } else if (type === 19) {
        return '門市取消'
      } else if (type === 50) {
        return '總部確認'
      } else if (type === 59) {
        return '總部取消'
      }
    },
    setBlackReason () {
      var self = this
      this.getBlackReason.forEach(function (o) {
        var obj = { text: o.reason, value: o.reason_type_id }
        self.bSelectOptions.options.push(obj)
      })
    },
    markBlack () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/order/markShopperBlack/' + orderId
      var data = {
        reason_type_id: this.selectBlackReason
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功標記黑名單',
            text: '成功標記黑名單',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getOrderInfo()
        }
      })
    },
    resendOrderNotify () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/order/resendOrderNotify/' + orderId
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    forceRefundOrder () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/accounting/forceRefundOrder'
      var data = {
        order_id: orderId
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getOrderInfo()
        }
      })
    },
    refundOrder () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/order/refundOrder/' + orderId
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    cancelShopperOrder () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/order/cancelShopperOrder/' + orderId
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    cancelPosOrder () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/order/cancelPosOrder/' + orderId
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    priceTypeName (type) {
      if (type === 1) {
        return '免稅'
      } else if (type === 2) {
        return '未稅價格'
      } else if (type === 3) {
        return '含稅價格'
      }
    },
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    tradeType (type) {
      if (type === 1) {
        return '現金'
      } else if (type === 701) {
        return 'iPASS MONEY'
      } else if (type === 706) {
        return '信用卡'
      } else if (type === 707) {
        return 'LINE PAY'
      } else if (type === 709) {
        return '信用卡(台新)'
      } else if (type === 710) {
        return '信用卡'
      } else if (type === 713) {
        return '台灣Pay'
      } else if (type === 716) {
        return '全盈+PAY'
      } else if (type === 717) {
        return '悠遊付'
      } else if (type === 718) {
        return 'Pi 拍錢包'
      } else if (type === 719) {
        return '全支付'
      } else if (type === 720) {
        return 'icash Pay'
      } else if (type === 908) {
        return '街口支付'
      } else if (type === 909) {
        return '遠傳電信代收'
      }
    },
    invoiceType (type, email) {
      if (email) {
        return 'Email 載具'
      } else {
        if (type === 10) return '紙本'
        else if (type === 20) return '載具'
        else if (type === 21) return 'POS載具'
        else if (type === 30) return '捐贈'
        else return '無發票/未指定'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '尚未付款'
      } else if (state === 12) {
        return '付款處理中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款處理中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderStateColor (state) {
      switch (state) {
        case 140: // 已作廢
        case 120: // 被店家退訂
        case 121: // 被系統退訂
        case 122: // 已取消
        case 99: // 使用者取消訂單
          return 'label-danger'
        case 100: // 未接單
          return 'label-default'
        case 110: // 已接單
          return 'label-primary'
        case 130: // 已完成
          return 'label-success'
        default:
          return 'label-warning'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '使用者取消訂單'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '被店家退訂'
      } else if (state === 121) {
        return '被系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    notifyType (type) {
      if (type === 1) {
        return '新訂單'
      } else if (type === 2) {
        return '使用者取消'
      } else if (type === 3) {
        return '系統自動拒絕'
      }
    },
    vendorType (type) {
      switch (type) {
        case 1: return '快遞'
        case 2: return '宅配'
      }
    },
    shippingStateColor (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三方取消(分派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'label-danger'
        case 0: // 叫件開案
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確定叫件
          return 'label-default'
        case 110: // 已接受叫件
          return 'label-pink'
        case 120: // 第三方已分派外送員
          return 'label-warning'
        case 130: // 司機已取貨,開始送貨
          return 'label-primary'
        case 140: // 司機已送達
          return 'label-success'
        default:
          return 'label-warning'
      }
    },
    shippingState (state) {
      if (state === 0) {
        return '叫件開案'
      } else if (state === 10) {
        return '已報價'
      } else if (state === 19) {
        return '報價失敗'
      } else if (state === 50) {
        return '叫件處理中'
      } else if (state === 59) {
        return '叫件處理失敗'
      } else if (state === 100) {
        return '成立物流單'
      } else if (state === 110) {
        return '物流接單'
      } else if (state === 120) {
        return '已分派外送員'
      } else if (state === 130) {
        return '已取貨'
      } else if (state === 140) {
        return '已送達'
      } else if (state === 900) {
        return '門市取消叫件'
      } else if (state === 901) {
        return '系統/門市取消'
      } else if (state === 910) {
        return '物流拒絕接單'
      } else if (state === 920) {
        return '媒合失敗'
      } else if (state === 921) {
        return '物流分派司機失敗'
      } else if (state === 930) {
        return '司機取餐失敗'
      } else if (state === 940) {
        return '司機送餐失敗'
      }
    },
    quotedStateColor (state) {
      switch (state) {
        case 99: // 報價發生錯誤
        case 90: // 物流拒絕報價
        case 91: // 無法服務
        case 92: // 非運送時段
        case 93: // 運送範圍不符
        case 94: // 運送距離不符
          return 'label-danger'
        case 0: // 未報價
          return 'label-default'
        case 10: // 物流已報價
          return 'label-success'
        default:
          return 'label-danger'
      }
    },
    quotedState (state) {
      switch (state) {
        case 1: return '報價中'
        case 99: return '報價發生錯誤'
        case 90: return '拒絕報價'
        case 91: return '無法服務'
        case 92: return '非運送時段'
        case 93: return '運送範圍不符'
        case 94: return '運送距離不符'
        case 0: return '未報價'
        case 10: return '已報價'
        default: return ''
      }
    },
    getOrderInfo () {
      return new Promise((resolve, reject) => {
        const orderId = this.$route.params.order_id
        const roleType = this.roleType
        var url = ''
        const orderType = this.isOffline ? 'offlineOrder' : 'order'
        if (this.isGuest) url = '/' + orderType + '/caseInfo/' + orderId
        else if (roleType === 99) url = '/' + orderType + '/orderInfo/' + orderId
        else if (roleType === 30) url = '/' + orderType + '/brandOrderInfo/' + orderId
        else if (roleType === 10) url = '/' + orderType + '/storeOrderInfo/' + orderId
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            let data = response.data
            this.orderList = data.order
            this.orderList = this.isGuest ? (data.case || {}) : (data.order || {})
            if (this.isGuest && this.orderList.offline_order_id) {
              // 如果訪客已轉成會員(offline_order_id 有值)，要跳轉到會員的頁面
              this.$router.replace({ path: '/onSiteOrderTableInfo/' + this.orderList.offline_order_id })
              return
            }
            this.productList = this.orderList.product_list || null

            this.bindingShipping = this.orderList.binding_shipping_case
            if (this.bindingShipping) this.getShippingCaseList(orderId)
            if (this.orderList.coupon_list) this.couponList = this.orderList.coupon_list
            if (this.orderList.get_coupon_list) this.getCouponList = this.orderList.get_coupon_list
            if (this.orderList.voucher_list) this.voucherList = this.orderList.voucher_list
            if (this.orderList.point.income.list) this.getPointList = this.orderList.point.income.list

            if (this.orderList.product_coupon_list) {
              this.productCouponList = this.orderList.product_coupon_list.item_list
              if (!Array.isArray(this.productCouponList)) this.productCouponList = Object.values(this.productCouponList)
              this.productCouponMap = {}
              this.productCouponList.forEach((item) => {
                this.productCouponMap[item.item_set_uid] = item
              })
            }

            if (this.orderList.product_voucher_list) {
              this.productVoucherList = this.orderList.product_voucher_list.item_list
              if (!Array.isArray(this.productVoucherList)) this.productVoucherList = Object.values(this.productVoucherList)
              this.productVoucherMap = {}
              this.productVoucherList.forEach((item) => {
                this.productVoucherMap[item.item_set_uid] = item
              })
            }

            if (this.orderList.rating) this.ratingList = this.orderList.rating
            if (this.orderList.membership_score) this.getMembershipScore = this.orderList.membership_score.income.list
            this.isOfflineOrder = this.orderList.pay_place_type !== 10 // 10: Nidin線上支付
            this.getMembershipDiscountInfo()
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    // TODO: 目前線下優惠券先只會存到 couponList 陣列資料，因 POS 目前沒有支援商品名稱功能，且後端尚未實作單品券資料存到 productCouponList 功能，但未來有可能會實作此功能
    offlineCouponList () {
      this.combineCouponList = []
      if (this.couponList.length) {
        this.couponList.forEach((coupon) => {
          this.combineCouponList.push(coupon)
        })
      }
      this.totalOfflineCouponMoney = this.combineCouponList.reduce((sum, item) => {
        if (item.money !== undefined) {
          return sum + item.money
        }
        return sum
      }, 0)
    },
    // TODO: 目前線下電子票券存到 voucherList 陣列資料，因 POS 目前沒有支援商品名稱功能，且後端尚未實作單品券資料存到 productVoucherList 功能，但未來有可能實作此功能
    offlineVoucherList () {
      this.combineVoucherList = []
      if (this.voucherList.length) {
        this.voucherList.forEach((voucher) => {
          this.combineVoucherList.push(voucher)
        })
      }
      this.totalOfflineVoucherMoney = this.combineVoucherList.reduce((sum, item) => {
        if (item.money !== undefined) {
          return sum + item.money
        }
        return sum
      }, 0)
    },
    selectOnChange (value) {
      this.order.newState = value
    },
    changeBlackReason (value) {
      this.selectBlackReason = value
    },
    inputOnChange (value) {
      this.order.remark = value
    },
    editOrderState () {
      if (this.order.newState === null) {
        this.$notify({
          title: '請選擇訂單狀態',
          duration: 3000,
          type: 'warn',
          width: 400
        })
        return
      }
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/order/updateOrderStatus/' + orderId
      var data = {
        status: this.order.newState
      }
      if (this.order.remark) data['remark'] = this.order.remark
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getOrderInfo()
        }
      })
    },
    checkMemberShow (status) {
      if (!this.isOffline) {
        if (this.roleType === 30) {
          if (status === 130 || status === 140) return true
          else return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    getShippingCaseList (orderId) {
      const orderType = this.isOffline ? this.isGuest ? 'directCase' : 'offlineOrder' : 'order'
      let url = `/shippingCase/${orderType}/${orderId}/list`
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          if (this.bindingShipping.vendor_code === 'glo') this.shippingCaseList = [res.data.list[0]]
          else this.shippingCaseList = res.data.list
        }
      })
    },
    getSrcTypeName (source, type) {
      if (source === 'point') {
        if (type === '10') {
          return '消費贈點'
        } else if (type === '60') {
          return '指定商品贈點'
        } else if (type === '61') {
          return '點數加碼活動'
        } else {
          return '未知'
        }
      } else if (source === 'memberScore') {
        if (type === '10') {
          return '消費贈積分'
        } else if (type === '60') {
          return '指定商品贈積分'
        } else if (type === '61') {
          return '積分加碼活動'
        } else {
          return '未知'
        }
      }
    },
    /**
     * 格式化優惠券或電子票券的核銷資料為顯示用格式
     * @param source 線上優惠券或電子票券的核銷資料
     */
    formatCouponVoucherList (source) {
      if (!source.item_list || typeof source.item_list !== 'object') return null
      const formatArray = []
      Object.values(source.item_list).forEach((value) => {
        const product = value
        const productName = product.list[0].product_name || '未知商品'
        const itemMap = {}
        if (product.list && Array.isArray(product.list)) {
          product.list.forEach((item) => {
            const itemName = item.name.toString() || ''
            if (itemMap[itemName]) {
              itemMap[itemName].count += 1
            } else {
              itemMap[itemName] = {
                count: 1,
                name: itemName,
                productName: productName,
                unitDiscount: item.unit_discount || 0
              }
            }
          })
        }
        formatArray.push({
          ...product,
          productName,
          formatList: itemMap
        })
      })
      return formatArray
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getBlackReason']),
    allCouponList () {
      let list = [...this.couponList]
      if (this.orderList.group_buy_follower_order_list) {
        this.orderList.group_buy_follower_order_list.forEach((order) => {
          list = list.concat(order.coupon_list)
        })
      }
      return list
    },
    allVoucherList () {
      let list = [...this.voucherList]
      if (this.orderList.group_buy_follower_order_list) {
        this.orderList.group_buy_follower_order_list.forEach((order) => {
          list = list.concat(order.voucher_list)
        })
      }
      return list
    },
    subSrcType () {
      switch (this.orderList.sub_src_type) {
        case 2: return 'LINE'
        case 3: return 'Messenger'
        case 4: return 'LINE LIFF'
        case 1:
        default:
          return '網頁'
      }
    },
    membershipDiscount () {
      if (this.orderList.membership_discount) {
        return this.orderList.membership_discount.list
      }
      return []
    },
    showTradeInfo () {
      let temp = true
      if (this.getRoleType !== 99) { // 不是 admin 不需要顯示
        temp = false
      }
      if (this.isOfflineOrder) { // 線下訂單不需要顯示
        temp = false
      }
      if (this.orderList.trade_type === 1) { // 付款方式是「現金」不需要顯示
        temp = false
      }
      return temp
    },
    totalCouponMoney () {
      var couponList = this.couponList
      if (couponList.length) {
        var total = 0
        couponList.forEach(function (coupon) {
          total = total + coupon.money
        })
        return total
      }
      return 0
    },
    getDataH () {
      return this.$parent.getDataH
    },
    reservEndTime () {
      var time = moment(this.orderList.delivery_reserv_time, 'YYYY-MM-DD HH:mm:ss').add(this.orderList.delivery_reserv_tolerance, 'm').format('HH:mm:ss')
      return time
    },
    isOffline () {
      // 是否為線下訂單
      return this.$route.name.includes('onSite')
    },
    isGuest () {
      // 是否為訪客單
      return this.$route.query.is_guest === '1'
    },
    replyUrl () {
      // 回覆 API URL
      return this.isOffline ? '/ratingOfflineOrder/' : '/rating/'
    },
    groupedPoints () {
      const grouped = {}

      // 依 src_type 分組
      this.getPointList.forEach(point => {
        const srcType = point.src_type
        if (!grouped[srcType]) {
          grouped[srcType] = []
        }
        grouped[srcType].push(point)
      })

      return grouped
    },
    groupedMembershipScore () {
      const grouped = {}

      // 依 src_type 分組
      this.getMembershipScore.forEach(item => {
        const srcType = item.src_type
        if (!grouped[srcType]) {
          grouped[srcType] = []
        }
        grouped[srcType].push(item)
      })

      return grouped
    },
    /**
     * 優惠券核銷詳情 > 優惠券 顯示用格式
     */
    productCouponListFormat () {
      return this.formatCouponVoucherList(this.orderList.product_coupon_list)
    },
    /**
     * 電子票券核銷詳情 > 電子票券 顯示用格式
     */
    voucherCouponListFormat () {
      return this.formatCouponVoucherList(this.orderList.product_voucher_list)
    },
    /**
     * 優惠券核銷詳情 > 優惠券 顯示用格式 (團購訂單：只有團員的)
     */
    gbProductCouponListFormat () {
      if (!this.orderList.group_buy_follower_order_list) return null
      const concatArray = this.orderList.group_buy_follower_order_list.map((order) => {
        return order.product_coupon_list
      })
      const formatList = []
      concatArray.forEach((item) => {
        const formatted = this.formatCouponVoucherList(item)
        if (formatted) {
          formatList.push(...formatted)
        }
      })
      return formatList
    },
    /**
     * 電子票券核銷詳情 > 電子票券 顯示用格式 (團購訂單：只有團員的)
     */
    gbVoucherCouponListFormat () {
      if (!this.orderList.group_buy_follower_order_list) return null
      const concatArray = this.orderList.group_buy_follower_order_list.map((order) => {
        return order.product_voucher_list
      })
      const formatList = []
      concatArray.forEach((item) => {
        const formatted = this.formatCouponVoucherList(item)
        if (formatted) {
          formatList.push(...formatted)
        }
      })
      return formatList
    },
    /**
     * 產品明細 > 詳情 > 優惠券 顯示用格式
     */
    infoProductCouponFormat () {
      return this.formatCouponVoucherList(this.info.product_coupon_list)
    },
    /**
     * 產品明細 > 詳情 > 電子票券 顯示用格式
     */
    infoVoucherCouponFormat () {
      return this.formatCouponVoucherList(this.info.product_voucher_list)
    },
    /**
     * 所有全單優惠券
     */
    couponListWithoutProduct () {
      return this.allCouponList.filter(coupon => !coupon.product_name)
    }

  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    this.getInfo()
  },
  watch: {
    '$route.query' () {
      this.getOrderInfo()
    },
    getBlackReason () {
      this.setBlackReason()
    }
  }
}
</script>
<style lang="sass">
.d-flex
  display: flex !important
.coupon-modal, .product-modal
  position: fixed
  top: 55px;
  background-color: #FFF
  z-index: 9999
  width: 600px
  left: calc(50% - 300px);
.v-middle
  vertical-align: middle !important
.bg-dark-gray
  background: #333
.product-option
  color: #333
  font-size: 14px
.text-worning
  color: #d73925
  font-weight: 600
.p-t-50
  padding-top: 30px
#process-1
  left: 50px
#process-2
  left: calc(100% / 3 - 25px)
#process-3
  left: calc(100% / 3 * 2 - 75px)
#process-4
  left: calc(100% - 150px)
.process-elem
  position: absolute
  top: 30px
  width: 100px
.progress-block
  max-width: 100%
  padding: 50px
.progress
  height: 12px
.text-25
  font-size: 25px
.bg-primary.input-group-addon
  background: #337ab7 !important
  border-color: #337ab7 !important
.m-y-5
  margin-top: 5px
  margin-bottom: 5px
.m-x-0
  margin-left: 0px !important
  margin-right: 0px !important
.m-l-auto
  margin-left: auto
.p-0
  padding: 0px !important
.p-l-5
  padding-left: 5px !important
.form-control.form-info
  border: none
  border-left: 1px solid #d2d6de
.form-info .label
  font-size: 15px
  border-radius: 5px !important
.form-left.p-l-10
  padding-left: 10px !important
.form-right.p-l-0
  padding-left: 0px !important
.form-right.p-r-10-p, .form-left.p-r-10-p
  padding-right: 10% !important
@media screen and (max-width: 991px)
  .form-right.p-r-10-p, .form-left.p-r-10-p
    padding-right: 10px !important
  .form-right.p-l-0
    padding-left: 10px !important
.order-list-box
  border: 1px solid #d2d6de
  border-radius: 3px
  padding: 10px 25px
  margin: 0px 10px
  p
    font-size: 15px
.b-0
  border: 0px
hr
  margin: 5px
.status-light
  border-radius: 50% !important
  width: 23px
  height: 23px
  top: 5px
.hint
  width: calc(100% - 20px)
  background: rgba(#3C8DBC, 0.1)
  border-radius: 4px
  border: 1px solid #3C8DBC
  text-align: left
  font-size: 14px
  padding: 10px !important
  margin: 20px 10px 30px
.dialog-border
  border-bottom: 1px solid #f4f4f4
  padding: 8px
</style>



// WEBPACK FOOTER //
// OrderInfo.vue?c794ad10